import * as types from './mutations'
import Vue from 'vue'

const state = {
    clients: {},
    client: {},
}

const mutations = {
    [types.FETCH] (state, clients)
    {
        state.clients = clients
    },
    [types.CLEAR] (state)
    {
        state.clients = {}
    },
    [types.FETCH_SINGLE] (state,data)
    {
        state.client = data
    },
}

const actions = {
    clientsFetch({commit}, params)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.get('/clients', { params: params })
                commit(types.FETCH, response.data)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },
    clientFetch({commit}, payload)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.get(`/clients/${payload.id}`)
                commit(types.FETCH_SINGLE, response.data)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },
    clientUpdate({commit}, payload)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.put(`/clients/${payload.id}`, payload)
                commit(types.FETCH_SINGLE, response.data)
            } catch (e) {
                reject(e)
            }
        })
    },
    logout({commit})
    {
        commit(types.CLEAR)
    },
}

const getters = {
    clients: state => JSON.parse(JSON.stringify(state.clients)),
    client: state => JSON.parse(JSON.stringify(state.client)),
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/clients/index.js